import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Login from './components/auth/Login';
import NuevaCuenta from "./components/auth/NuevaCuenta";
import Proyectos from './components/proyectos/Proyectos';

import Consumos from './components/tareas/consumos/Consumos';
import NuevoConsumo from './components/tareas/consumos/NuevoConsumo';
import EditarConsumo from './components/tareas/consumos/EditarConsumo';

import Paneles from './components/tareas/paneles/Paneles';

import Inversores from './components/tareas/inversores/Inversores';

import Baterias from './components/tareas/baterias/Baterias';

import ProyectoState from './context/proyectos/proyectoState';
import ConsumoState from './context/consumos/consumoState';
import XtareaState from './context/extratareas/xtareaState';
import AlertaState from './context/alertas/alertaState';
import AuthState from './context/autenticacion/authState';
import tokenAuth from './config/token';
import RutaPrivada from './components/rutas/RutaPrivada';

// revisar si tenemos un token
const token = localStorage.getItem('token');
if (token) {
  tokenAuth(token);
}

function App() {
  
  return (
    <ProyectoState>
    <ConsumoState>
    <XtareaState>
    <AlertaState>
    <AuthState>
      <Router>    
        <div className="container mt-5" >
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/nueva-cuenta" component={NuevaCuenta} />
            <RutaPrivada exact path="/proyectos" component={Proyectos} />
            <Route exact path="/proyectos/consumos" component={Consumos} />
            <Route exact path="/proyectos/consumos/nuevo" component={NuevoConsumo} />
            <Route exact path="/proyectos/consumos/editar/:id" component={EditarConsumo} />
            <Route exact path="/proyectos/paneles" component={Paneles} />
            <Route exact path="/proyectos/inversores" component={Inversores} />
            <Route exact path="/proyectos/baterias" component={Baterias} />
          </Switch>
        </div>
      </Router>
    </AuthState>      
    </AlertaState>      
    </XtareaState>    
    </ConsumoState>      
    </ProyectoState>
    
  );
}

export default App;
